import type { FaireProductEntity } from "../../entity_types/product";

export const p_sfemj7hh82: FaireProductEntity = {
  token: "p_sfemj7hh82",
  type: "product",
  name: "Oyster - Enamel Pin",
  brandName: "Statement Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/0ce3c47d2855b90d6ca91c652970acbdc42f00297f518df1a9a74048c768b20c.jpeg",
  priceDollars: 6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/4d6eaf007fdace9d392e198bd16a8e02bfb809cb9e0e53e970213c06b8642226.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
